import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IMG } from "../data/content";

export default function AuthShell({ eyebrow, title, children, footer }) {
  return (
    <section className="min-h-screen grid lg:grid-cols-2" data-testid="auth-shell">
      <div className="relative hidden lg:block bg-ink-900 grain overflow-hidden">
        <img src={IMG.blueRobot} alt="Industrie 4.0" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-900/60 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <Link to="/" className="font-display text-2xl font-bold text-paper tracking-tight">NOVA<span className="text-gold">LEAN</span></Link>
          <div>
            <p className="font-display text-3xl xl:text-4xl font-medium text-paper leading-tight max-w-md">
              « L'excellence opérationnelle se construit sur le terrain, avec les équipes. »
            </p>
            <p className="label-mono text-gold mt-6">Lean Today, Better Tomorrow</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-paper">
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-md"
        >
          <Link to="/" className="lg:hidden font-display text-2xl font-bold tracking-tight mb-8 inline-block">NOVA<span className="text-gold">LEAN</span></Link>
          <span className="label-mono text-gold">{eyebrow}</span>
          <h1 className="font-display text-4xl md:text-5xl font-semibold mt-3 tracking-tight leading-[0.95]">{title}</h1>
          <div className="mt-10">{children}</div>
          <div className="mt-8 text-ink/60 text-sm">{footer}</div>
        </motion.div>
      </div>
    </section>
  );
}
